import React from 'react';
import ButtonSwitch from 'shared/components/button-switch/ButtonSwitch';
import ChangePassword from './ChangePassword';

class SettingsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div className="settings-form">
        <div className="settings-title">Settings</div>
        {/*<div className="settings-section">
          <span>Notifications</span>
          <ButtonSwitch />
        </div>*/}
        <div className="settings-section">
          <span className="action" onClick={this.toggle}>
            Change Password
          </span>
        </div>
        <div className="settings-section">
          <a
            href="mailto:hybrid@sidebench.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Email Support
          </a>
        </div>
        <ChangePassword isOpen={this.state.modal} toggle={this.toggle} />
      </div>
    );
  }
}

export default SettingsForm;
